import { render, staticRenderFns } from "./ResumeTransporter.vue?vue&type=template&id=2edf3e5e"
import script from "./ResumeTransporter.vue?vue&type=script&lang=js"
export * from "./ResumeTransporter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports